module.exports = __webpack_public_path__ + "assets/img/logo-white.9ccfd87b.png";